// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2NuO2","withIcons":"_1uOLS","ltr":"_3gdA9","user":"_1qtDu","rtl":"_34F_W","name":"_1i-z_","newArrow":"_3LXUz","arrow":"_1hHt1"};